<div class="row">
	<div class="col-sm-12">
		<div class="card card-border">
			<div class="container card-body table-responsive">
				<div class="row">
					<div class="col-md-12">

						<div id="accordion" class="accordion">
							<div class="card mb-1" *ngFor="let row of dataProyectoRiesgo; let indiceUno = index">
								<div class="card-header py-0 px-0 my-0" id="headingNine">
									<h5 class="accordion-header py-0" id="headingOne">
										<a class="accordion-button  py-2 text-reset" data-bs-toggle="collapse" href="#id_{{ indiceUno + 1 }}" aria-expanded="true" aria-expanded="true"
											aria-controls="collapseOne">
											{{"PROYECTO " + (indiceUno+1) + ".- "}}{{ row.proyecto }}
										</a>
									</h5>
								</div>

								<div id="id_{{ indiceUno + 1 }}" class="collapse" aria-labelledby="abcd"
									data-bs-parent="#accordion">
									<div class="card-body">
										<div class="row">


											<div class="row" *hasDenied="{nivel:idSprNivel, app: constant.RIESGOS}">
												<div class="col-sm-6 text-sm-right">
													<button	*hasPermission="{app: constant.RIESGOS, permission: [constant.CREAR]}" type="button" class="btn btn-sm btn-success waves-effect" (click)="openModal(row)">
														<i class="fas fa-plus fa-lg mr-1"></i> Nuevo</button>
												</div>
											</div>
											<div class="container card-body table-responsive">
												<table class="table table-striped table-bordered row-border hover">
													<thead>
														<tr>
															<th>Nro.</th>
															<th>Riesgo</th>
															<th>Probabilidad</th>
															<th>Impacto</th>
															<th>Calificación</th>
															<th>Responsable</th>
															<th>Fecha de ultima actualización</th>
															<th>Acciones cerradas totales</th>
															<th>Estado</th>
															<th>Gestión Acciones</th>
															<th>Acciones</th>
														</tr>
													</thead>
													<tbody>
														<tr
														*ngFor="let editRowfechas of dataProyectoRiesgo[indiceUno].dataRiesgoMap;let indice = index ">
														<td>{{ indice + 1 }}</td>
														<td>{{ editRowfechas.nombre }}</td>
														<td>{{ editRowfechas.probabilidad }} %</td>
														<td>{{ editRowfechas.impacto }} %</td>
														<td>{{ editRowfechas.calificacion }} %</td>
														<td>{{ editRowfechas.gradoNombres}}</td>
														<td>{{ editRowfechas.fecha | date: 'dd-MM-yyyy'}}</td>
														<td>1</td>
														<td>{{editRowfechas.estado == "1"? "Activo": "Inactivo"}}</td>
														<td class="text-center col-sm-auto">
															<button type="button" tooltip="Gestionar" class="btn btn-sm btn-link waves-effect rounded-pill"
																title="Editar este registro" (click)="openModalGestion(editRowfechas)">
																<i class="fas fa-tasks fa-lg"></i>
															</button>
														</td>
														<td class="text-center">
															<!-- Negar/permitir para todo el elemento -->

															<div class="row" *hasDenied="{nivel:idSprNivel, app: constant.RIESGOS}">
																<button	*hasPermission="{app: constant.RIESGOS, permission: [constant.ACTUALIZAR]}"	type="button" tooltip="Editar" class="btn btn-sm btn-link waves-effect rounded-pill col px-0" title="Editar este registro" (click)="edit(editRowfechas,row)">
																	<i class="fas fa-pencil-alt fa-lg"></i>
																</button>
																<button	*hasPermission="{app: constant.RIESGOS, permission: [constant.BORRAR]}"	type="button" class="btn btn-sm btn-link waves-effect col px-0" title="Eliminar este registro" (click)="delete(editRowfechas.idSprRiesgo)">
																	<i class="fas fa-trash-alt fa-lg"></i>
																</button>
															</div>
															<!-- Negar/permitir solo para un item de riesgo -->
															<div class="row" *hasDeniedItems="{idSprAmbiente:idSprAmbiente, itemElemento:row.idSprRiesgo, tipoElemento:'riesgo'}">
																<button *hasPermission="{app: constant.RIESGOS, permission: [constant.ACTUALIZAR]}"	type="button" tooltip="Editar" class="btn btn-sm btn-link waves-effect rounded-pill" title="Editar este registro"
																	(click)="edit(editRowfechas,row)">
																	<i class="fas fa-pencil-alt fa-lg"></i>
																</button>
																<button	*hasPermission="{app: constant.RIESGOS, permission: [constant.BORRAR]}"	type="button" class="btn btn-sm btn-link waves-effect" title="Eliminar este registro" (click)="delete(editRowfechas.idSprRiesgo)">
																	<i class="fas fa-trash-alt fa-lg"></i>
																</button>
															</div>
														</td>
													</tr>
													</tbody>
												</table>
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>

		<!-- MODAL PARA LA CONFIRMACION DEL BORRADO -->
		<jw-modal id="delRiesgoProyecto" [isDelete]="true" (confirmation)="confirmDelete()"></jw-modal>

		<!-- ############################################################################################################# -->
		<!-- ######################################    MODALES       ##################################################### -->
		<!-- ############################################################################################################# -->

		<jw-modal id="{{ nameModalRiesgoP }}">
			<!-- MODAL PARA CREAR Y EDITAR -->
			<div class="modal-dialog modal-lg modal-dialog-scrollable" style="padding-top:6%">
				<div class="modal-content">
					<div class="modal-header pb-6">
						<h3 class="texto-negritas-centrado">{{ nameAppP }}</h3>
						<button type="button" class="btn-close" (click)="modal.close()" aria-label="Close"></button>
					</div>
					<div class="modal-body pT-4">
						<div class="card-header  mb-2">
							<div class="form-group row mb-2">
								<div class="pservices text-justify">
									<span><b>PROYECTO: </b>{{ elementoActual }}</span>
								</div>
							</div>
						</div>


						<form action="#" [formGroup]="formRiesgo" class="needs-validation ">
							<div class="form-group row mb-2">
								<div class="col col-md-2 text-md-right ">
									<label for="nombre" class="col-form-label text-md-right"><b>Nombre:</b>
									</label>
								</div>
								<div class="col-12 col-md-10 ">
									<textarea type="text" id="idSprRiesgo" type="text" class="form-control"	required="true" formControlName="nombre" oninput="this.value" [ngClass]="{'is-invalid': this.formRiesgo.get('nombre')?.errors && this.submitted,'is-valid': !this.formRiesgo.get('nombre')?.errors,
							  }">
							   </textarea>
									<div class="col text-danger">
										<span class="font-italic" *ngIf="this.formRiesgo.get('nombre')?.errors?.['required'] && this.submitted">Campo requerido</span>
									</div>
								</div>
							</div>
							<div class="form-group row mb-2">
								<div class="col col-md-2 text-md-right ">
									<label for="descripcion" class="col-form-label text-md-right"><b>Descripción:</b>
									</label>
								</div>
								<div class="col-12 col-md-10 ">
									<textarea type="text" class="form-control" required="true" formControlName="descripcion" [ngClass]="{'is-invalid': this.formRiesgo.get('descripcion')?.errors && this.submitted,'is-valid': !this.formRiesgo.get('descripcion')?.errors,}">
							  </textarea>
									<div id="contador"></div>
									<small class="invalid-feedback"	*ngIf="this.formRiesgo.get('descripcion')?.errors?.['required'] && this.submitted">Campo requerido</small>
								</div>
							</div>

							<div class="form-group row mb-2">
								<div class="col col-md-2 text-md-right">
									<label for="fechaIdentificacion" class="form-control-label text-md-right pt-1"><b>Fecha	identificación:</b></label>
								</div>
								<div class="col-12 col-md-4">
									<input type="date" class="form-control" required="true"	placeholder="fechaIdentificacion" formControlName="fechaIdentificacion"
										[ngClass]="{'is-invalid': this.formRiesgo.get('fechaIdentificacion')?.errors && this.submitted,'is-valid': !this.formRiesgo.get('fechaIdentificacion')?.errors, }" />
									<div class="col text-danger">
										<span class="font-italic" *ngIf="this.formRiesgo.get('fechaIdentificacion')?.errors?.['required'] && this.submitted">Campo requerido</span>
										<span class="font-italic" *ngIf="this.formRiesgo.get('fechaIdentificacion').errors?.fechaInicio">La	fecha debe estar comprendida entre{{this.formRiesgo.get('fechaIdentificacion')?.errors.fechaInicio}} y {{this.formRiesgo.get('fechaIdentificacion')?.errors.fechaFin}} </span>
									</div>
								</div>

								<div class="col col-md-2 text-md-right">
									<label for="fechaOcurrencia" class="form-control-label text-md-right pt-1"><b>Fecha	ocurrente:</b></label>
								</div>
								<div class="col-12 col-md-4">
									<input type="date" class="form-control" required="true"	placeholder="fechaOcurrencia" formControlName="fechaOcurrencia"	[ngClass]="{'is-invalid': this.formRiesgo.get('fechaOcurrencia')?.errors && this.submitted,'is-valid': !this.formRiesgo.get('fechaOcurrencia')?.errors, }" />
									<div class="col text-danger">
										<span class="font-italic" *ngIf="this.formRiesgo.get('fechaOcurrencia')?.errors?.['required'] && this.submitted">Campo requerido</span>
										<span class="font-italic" *ngIf="this.formRiesgo.get('fechaOcurrencia').errors?.fechaInicio">La	fecha debe estar comprendida entre
											{{this.formRiesgo.get('fechaOcurrencia')?.errors.fechaInicio}}	y {{this.formRiesgo.get('fechaOcurrencia')?.errors.fechaFin}} </span>
									</div>
								</div>
							</div>

							<div class="form-group row mb-2">
								<div class="col col-md-2 text-md-right">
									<label for="probabilidad" class="form-control-label text-md-right pt-1"><b>Probabilidad (%)</b>
									</label>
								</div>
								<div class="col-12 col-md-4">
									<select class="form-select" id="probabilidad" formControlName="probabilidad" required="true" [ngClass]="{'is-invalid': this.formRiesgo.get('probabilidad')?.errors && this.submitted,'is-valid': !this.formRiesgo.get('probabilidad')?.errors, }">
										<option value="" selected>Seleccione</option>
										<option value="0">0 %</option>
										<option value="10">10 %</option>
										<option value="20">20 %</option>
										<option value="30">30 %</option>
										<option value="40">40 %</option>
										<option value="50">50 %</option>
										<option value="60">60 %</option>
										<option value="70">70 %</option>
										<option value="80">80 %</option>
										<option value="90">90 %</option>
										<option value="100">100 %</option>
									</select>
									<div class="col text-danger">
										<span class="font-italic" *ngIf="this.formRiesgo.get('probabilidad')?.errors?.['required'] && this.submitted">Campo requerido
										</span>
									</div>
								</div>

								<div class="col col-md-2 text-md-right">
									<label for="impacto" class="form-control-label text-md-right pt-1"><b>Impacto (%)</b>
									</label>
								</div>
								<div class="col-12 col-md-4">
									<select class="form-select" id="impacto" formControlName="impacto" required="true" [ngClass]="{'is-invalid': this.formRiesgo.get('impacto')?.errors && this.submitted,'is-valid': !this.formRiesgo.get('impacto')?.errors, }">
										<option value="" selected>Seleccione</option>
										<option value="0">0 %</option>
										<option value="10">10 %</option>
										<option value="20">20 %</option>
										<option value="30">30 %</option>
										<option value="40">40 %</option>
										<option value="50">50 %</option>
										<option value="60">60 %</option>
										<option value="70">70 %</option>
										<option value="80">80 %</option>
										<option value="90">90 %</option>
										<option value="100">100 %</option>
									</select>
									<div class="col text-danger">
										<span class="font-italic" *ngIf="this.formRiesgo.get('impacto')?.errors?.['required'] && this.submitted">Campo requerido</span>
									</div>
								</div>
							</div>

							<div class="form-group row mb-2">
								<div class="col col-md-2 text-md-right">
									<label for="calificacion" class="form-control-label text-md-right pt-1"><b>Calificación (%):</b>
									</label>
								</div>
								<div class="col-12 col-md-4">
									<input class="form-control" disabled style="background-color: #f5f4f4;" placeholder="{{ calificacion() }} %" />
								</div>

								<div class="col col-md-2 text-md-right">
									<label for="costoPotencial" class="form-control-label text-md-right pt-1"><b>Costo potencial ($):</b></label>
								</div>
								<div class="col-12 col-md-4">
									<input type="number" class="form-control" required="true" id="costoPotencial" placeholder="" formControlName="costoPotencial" number step="0.01" min="0" max="100" maxlength="3" onkeydown="return true" [ngClass]="{'is-invalid': this.formRiesgo.get('costoPotencial')?.errors && this.submitted,'is-valid': !this.formRiesgo.get('costoPotencial')?.errors, }" />
									<div class="col text-danger">
										<span class="font-italic" *ngIf="this.formRiesgo.get('costoPotencial')?.errors?.['required'] && this.submitted">Campo requerido</span>
									</div>
								</div>
							</div>

							<div class="form-group row mb-2">
								<div class="col col-md-2 text-md-right">
									<label for="idSprEstructuraEdr" class="col-form-label text-md-right"><b>Estructura (EDR):</b></label>
								</div>
								<div class="col-12 col-md-4">
									<select class="form-select" id="idSprEstructuraEdr" formControlName="idSprEstructuraEdr" required="true" [ngClass]="{'is-invalid': this.formRiesgo.get('idSprEstructuraEdr')?.errors && this.submitted,'is-valid': !this.formRiesgo.get('idSprEstructuraEdr')?.errors, }">
										<option value="" selected="selected">
											Seleccionar..
										</option>
										<option *ngFor="let catRiesgoEdr of dataCatComun" value="{{ catRiesgoEdr.idSprComun }}">
											{{ catRiesgoEdr.nombre }}
										</option>
									</select>
									<div class="col text-danger">
										<span class="font-italic" *ngIf="this.formRiesgo.get('idSprEstructuraEdr')?.errors?.['required'] && this.submitted">Campo requerido</span>
									</div>
								</div>

								<div class="col col-md-2 text-md-right">
									<label for="fechaCierre" class="form-control-label text-md-right pt-1"><b>Fecha cierre:</b>
									</label>
								</div>
								<div class="col-12 col-md-4">
									<input type="date" class="form-control" required="true" placeholder="fechaCierre" formControlName="fechaCierre" [ngClass]="{'is-invalid': this.formRiesgo.get('fechaCierre')?.errors && this.submitted,'is-valid': !this.formRiesgo.get('fechaCierre')?.errors, }" />
									<div class="col text-danger">
										<span class="font-italic" *ngIf="this.formRiesgo.get('fechaCierre')?.errors?.['required'] && this.submitted">Campo requerido</span>
										<span class="font-italic" *ngIf="this.formRiesgo.get('fechaCierre').errors?.fechaInicio">La fecha debe estar comprendida entre
											{{this.formRiesgo.get('fechaCierre')?.errors.fechaInicio}} y {{this.formRiesgo.get('fechaCierre')?.errors.fechaFin}} </span>
									</div>
								</div>
							</div>

							<div class="form-group row mb-2">
								<div class="col col-md-2 text-md-right">
									<label for="idSprEquipoGerencial" class=" form-control-label text-md-right pt-1"><b>Responsable:</b></label>
								</div>
								<div class="col-12 col-md-4">
									<select class="form-select" id="idSprEquipoGerencial" formControlName="idSprEquipoGerencial" required="true" [ngClass]="{'is-invalid': this.formRiesgo.get('idSprEquipoGerencial')?.errors && this.submitted,'is-valid': !this.formRiesgo.get('idSprEquipoGerencial')?.errors, }">
										<option value="" selected="selected">
											Seleccionar..
										</option>
										<option *ngFor="let row of dataResponsable" value={{row.idSprEquipoGerencial}}>
											{{row.gradoNombres}}
										</option>
									</select>
									<div class="col text-danger">
										<span class="font-italic" *ngIf="this.formRiesgo.get('idSprEquipoGerencial')?.errors?.['required'] && this.submitted">Campo
											requerido</span>
									</div>
								</div>

								<div class="col col-md-2 text-md-right">
									<label for="estadoRiesgo" class="col-form-label text-md-right"><b>Estado Riesgo:</b></label>
								</div>
								<div class="col-12 col-md-4">
									<select class="form-select" id="estadoRiesgo" formControlName="estadoRiesgo" required="true" [ngClass]="{'is-invalid': this.formRiesgo.get('estadoRiesgo')?.errors && this.submitted,'is-valid': !this.formRiesgo.get('estadoRiesgo')?.errors, }">
										<option [value]="item.value" *ngFor="let item of itemEstadoRiesgo">
											{{ item.label }}
										</option>
									</select>
									<div class="col text-danger">
										<span class="font-italic" *ngIf="this.formRiesgo.get('estadoRiesgo')?.errors?.['required'] && this.submitted">Campo requerido</span>
									</div>
								</div>
							</div>

							<div class="form-group row mb-2">
								<div class="col col-md-2 text-md-right">
									<label for="estado" class="col-form-label text-md-right"><b>Estado:</b></label>
								</div>
								<div class="col-12 col-md-4">
									<select class="form-select" id="estado" formControlName="estado" required="true" [ngClass]="{'is-invalid': this.formRiesgo.get('estado')?.errors && this.submitted,'is-valid': !this.formRiesgo.get('estado')?.errors, }">
										<option [value]="item.value" *ngFor="let item of selectItems">
											{{ item.label }}
										</option>
									</select>
									<div class="col text-danger">
										<span class="font-italic" *ngIf="this.formRiesgo.get('estado')?.errors?.['required'] && this.submitted">Campo requerido</span>
									</div>
								</div>
							</div>

						</form>
					</div>
					<div class="modal-footer">
						<button type="button" class="btn btn-secondary waves-effect" (click)="modal.close()">Cerrar</button>
						<button type="button" class="btn btn-info" (click)="onSubmit()">Guardar</button>
					</div>
				</div>
			</div>
		</jw-modal>

		<jw-modal id="{{ nameModalGestionRP }}">
			<div class="modal-dialog modal-xl modal-dialog-scrollable" style="padding-top: 6%">
				<div class="modal-content">
					<div class="modal-header pb-3">
						<h3 class="modal-title">{{ nameAppGestionRP }}</h3>
						<button type="button" class="btn-close" (click)="modal.closeId(nameModalGestionRP)"	aria-label="Close"></button>
					</div>
					<div class="modal-body  pT-4">
						<app-accion-proyecto [data]="idRiesgoSeleccionado"></app-accion-proyecto>
					</div>
					<div class="modal-footer">
						<button type="button" class="btn btn-secondary waves-effect" (click)="modal.closeId(nameModalGestionRP)">
							Cerrar
						</button>
					</div>
				</div>
			</div>
		</jw-modal>
	</div>
</div>